import styled from 'styled-components';

export const NavWrapper = styled.nav`
  margin: 2rem 0 1rem 0;
  overflow: auto;
  overscroll-behavior-y: contain;

  @media (min-width: 500px) and (max-width: 1279px) {
    width: 278px;
  }

  @media (min-width: 500px) and (orientation: landscape) {
    overflow: auto;
    overscroll-behavior-y: contain;
  }

  & > ul {
    padding-top: 1rem;

    @media (min-width: 500px) {
      padding-top: 0;
    }
  }
`;

export const UnorderedList = styled.ul`
  margin: 0;
  padding: 0;

  & li {
    list-style-type: none;
  }
`;

export const ItemParent = styled.li.withConfig({
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})`
  color: #3c3c3b;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 120%;
  padding: 1rem 0.5rem;

  & svg {
    transform: rotate(180deg);
    transition: all 0.3s ease-in-out;
  }

  & a {
    width: max-content;

    & :focus,
    :hover {
      text-decoration: none;

      & hr {
        border: 1px solid #fed200;
        width: 100%;
      }
    }
  }
  & div {
    transition: all 0.3s ease-in-out;
    margin-bottom: 0;
    cursor: pointer;
  }

  & ul {
    max-height: 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    visibility: hidden;
  }

  & ul li {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    visibility: hidden;
  }
  ${(props) =>
    props.isExpanded &&
    `
    @media (min-width: 1280px) { background-color: #f7faf9; }

    padding: 1rem 0.5rem 0 0.5rem;

    & > div {
      margin-bottom: 1rem;
    }

    & ul > div {
      margin-bottom: 1.875rem;
    }

    & ul > div: last-child {
      margin-bottom: 0.5rem;
      @media (min-width: 1280px) { margin-bottom: 0; }
    }

    & ul {
      margin-left: 0.5rem;
      max-height: 100vh;
      opacity: 1;
      visibility: visible;

      @media (min-width: 1280px) { margin-left: 0; }

      & > div {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
    }

    & ul li {
      max-height: 100vh;
      opacity: 1;
      visibility: visible;
    }

    & svg {
        transform: rotate(0deg);
      }
  `}
`;

export const ItemMenu = styled.li.withConfig({
  shouldForwardProp: (prop) => prop !== 'isSubEntry',
})`
  color: #3c3c3b;
  font-weight: 400;
  letter-spacing: 0.5px;
  line-height: 140%;
  ${(props) => props?.isSubEntry && 'margin: 0 0 0 1rem;'}
`;

export const Underline = styled.hr`
  border-bottom: none;
  border-left: none;
  border-right: none;
  border: 1px solid transparent;
  justify-self: center;
  margin: 0;
  transition: all 0.3s ease-in-out;
  width: 0;
`;

export const Category = styled.li`
  color: rgba(60, 60, 59, 0.5);
  cursor: default;
  font-family: DM-Mono;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 1.5px;
  line-height: 142%; /* 17.04px */
  text-transform: uppercase;
`;
